<template>
	<div class="info">
		<h3 class="textcenter">退款确认书</h3>
		<p class="textindent">
			1、每个用户只能提出一次退款申请；超过一次的，平台有权拒绝。用户在此授权疯狂游戏平台（以下简称“平台”）有权核实其提供的全部资料的真实性，包括但不限于：对证据资料和证明资料进行自行核查或委托第三方进行核查、审查用户ID等，同时授权平台有权根据平台审核结果处置该账号，包括但不限于永久查封账号、销毁账号内道具等。
		</p>
		<p class="textindent">
			2、用户应当对本确认书的沟通和签署过程保密，不得向任何第三方披露或透露与本确认书相关的任何内容，包括但不限于：退款金额、平台联系方式、与平台的沟通内容等全部信息。用户未遵守保密义务的，视为泄露了平台的商业秘密，平台有权要求用户承担由此引发的全部法律责任。
		</p>
		<p class="textindent">
			3、用户应充分保证所提交的资料和用户描述的事件真实性，如后续平台发现有证据证明提交的资料或用户描述的事件的有不实成分，平台有权要求用户返还全部已退款项。
		</p>
		<p class="textindent">
			4、平台核实提交资料和用户描述的事件属实后，按照用户提供资料完成退款的，视为平台已履行全部义务，用户不得再提出其他主张。
		</p>
		<p class="textindent">
			5、用户确认知晓并同意平台在收到其提交的申诉材料后，会对账号做临时冻结处理，冻结期间用户将无法登录游戏，且冻结期间造成的损失由用户自行承担（如：游戏内活动无法参与等）。退款成功后，该账号下的所有数据将被永久冻结，用户将无法登录游戏且无法解冻。
		</p>
		<p class="textindent">
			6、因本确认书涉及的事宜履行发生争议的，任何一方均有权将争议提交平台住所地有管辖权的法院诉讼解决。
		</p>
		<p class="textindent">
			7、本确认书及相关的文件的版权归平台方所有，平台方保留一切对本确认书及相关文件的解释权。
		</p>
		<div class="textcenter" style="margin: 20px">
			<el-button type="primary" @click="$router.push({ name: 'config' })"
				>我同意以上协议, 并提交信息</el-button
			>
		</div>
		<div class="textcenter">
			<!-- <el-button
				type=""
				:style="{ width: isDesktop ? '150px' : '217.78px' }"
				@click="handleDialog('')"
				>申请流程</el-button
			> -->
			<!-- <br v-if="!isDesktop" /> -->
			<el-button
				type=""
				:style="{
					width: '217.78px',
					margin: isDesktop ? '0 20px' : '20px',
				}"
				@click="handleDialog('faq')"
				>常见问题解答</el-button
			>
			<!-- <br v-if="!isDesktop" /> -->
			<!-- <el-button
				type=""
				:style="{ width: isDesktop ? '150px' : '217.78px' }"
				@click="handleDownload"
				>下载退款确认书</el-button
			> -->
		</div>
		<el-dialog
			:title="dialogType == 'faq' ? '常见问题解答' : '退款流程'"
			:visible.sync="isDialog"
			:width="isDesktop ? '40%' : '92%'"
		>
			<div v-if="dialogType == 'faq'">
				<p>1、如何找到游戏客服？</p>
				<p class="answer">
					您可以关注微信公众号【疯狂游乐场VIP主站】点击【联系客服】选择对应游戏进行咨询，客服会尽力为您解答。
				</p>
				<p>
					2、目前是否提供电话客服？
				</p>
				<p class="answer">
					目前客服以工单形式进行回复，暂无电话服务。联系客服步骤详见第一条。
				</p>
				<p>3、充值记录哪里找？被删除了怎么办？</p>
				<p class="answer">充值记录需要到您进入微信钱包 - 点击账单 - 点开相关的充值 - 进行截图，如已经删除需要您联系微信客服查询一下相关的商户单号。</p>
				<p>4、相关证明目前因特殊原因无法提供，孩子误充值退款有没有时间限制？</p>
				<p class="answer">只要判定确实是孩子误充值导致的，我们一定会全额退款，没有时间限制，您可以在证件齐全了之后再来提交。</p>
				<p>5、自己与孩子不是直系监护人关系怎么办？</p>
				<p class="answer">
					需要让孩子直系监护人与我们取得联系。
				</p>
				<p>6、退款的款项去哪里领？</p>
				<p class="answer">
					退款款项会通过原充值渠道进行返还。
				</p>
				<p>7、提交的信息是否会被泄露？</p>
				<p class="answer">
					游戏平台不会泄露您任何的隐私信息，您可以在身份证、户口本的照片上打上水印。如：仅供xx游戏退款所用（关键信息处不可有遮挡）
				</p>
				<p>8、信息提交后需要等多久？</p>
				<p class="answer">
					我们预计会在7个工作日内以短信形式通知您材料是否通过审核，材料审核通过后，工作人员将与您和孩子约定时间进行视频沟通，最后会综合评定是否通过。
				</p>
				<p>9、退款成功后，是否会冻结账号</p>
				<p class="answer">
					是。
				</p>
			</div>
			<img
				v-else
				style="width: 100%"
				src="https://wxmini-resource.hortorgames.com/background-image/Lark20201112-145110.png"
				alt=""
			/>
		</el-dialog>
	</div>
</template>

<script>
import $api from '@api';
import { isDesktop } from '@utils/lib';

export default {
	data() {
		return {
			isDesktop: true,
			isDialog: false,
			dialogType: '',
		};
	},

	methods: {
		handleDialog(type) {
			this.dialogType = type;
			this.isDialog = true;
		},
		handleDownload() {
			const url = 'https://gc-img.oss-cn-qingdao.aliyuncs.com/%E9%80%80%E6%AC%BE%E7%A1%AE%E8%AE%A4%E4%B9%A6.docx';
			window.open(url);
		},
	},

	created() {
		this.isDesktop = isDesktop();
	},
};
</script>

<style scoped>
.info {
	padding: 18px;
}

.answer {
	color: #245bdb;
}
</style>
